import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AdminUser } from '../types/admin';

interface AdminState {
  user: AdminUser | null;
  adminToken: string | null;
  adminRefreshToken: string | null;
  isAdminAuthenticated: boolean;

  setAuth: (user: AdminUser, adminToken: string, adminRefreshToken: string) => void;
  setTokens: (adminToken: string, adminRefreshToken: string) => void;
  logout: () => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      user: null,
      adminToken: null,
      adminRefreshToken: null,
      isAdminAuthenticated: false,

      setAuth: (user, adminToken, adminRefreshToken) =>
        set({
          user,
          adminToken,
          adminRefreshToken,
          isAdminAuthenticated: true,
        }),

      setTokens: (adminToken, adminRefreshToken) =>
        set({ adminToken, adminRefreshToken }),

      logout: () =>
        set({
          user: null,
          adminToken: null,
          adminRefreshToken: null,
          isAdminAuthenticated: false,
        }),
    }),
    {
      name: 'admin-storage',
      partialize: (state) => ({
        user: state.user,
        adminToken: state.adminToken,
        adminRefreshToken: state.adminRefreshToken,
        isAdminAuthenticated: state.isAdminAuthenticated,
      }),
    },
  ),
);
